<template>
  <modal-with-opener>
    <template #opener="{ openModal }">
      <p style="text-align: center">
        <button
          class="button button--shadow button--lg qa-comment-mask__button"
          type="button"
          @click="openModal"
        >
          <picture>
            <source
              class="push-right--sm"
              srcset="~green/logo/social-icon-lst.webp"
              type="image/webp"
              height="16px"
            />
            <img
              class="push-right--sm"
              src="~green/logo/social-icon-lst.png"
              alt=""
              height="16px"
            />
          </picture>
          でログイン<br />
          登録して記事を見る
        </button>
      </p>
    </template>

    <template #modal-content>
      <paying-registration-modal-content
        :additional-params="additionalParams"
        :email-registration-url="emailRegistrationUrl"
        :last-login-method="lastLoginMethod"
      />
    </template>
  </modal-with-opener>
</template>

<script lang="ts">
import ModalWithOpener from '../common/component/ModalWithOpener.vue';
import PayingRegistrationModalContent from '../registration/PayingRegistrationModalContent.vue';

export default {
  components: { PayingRegistrationModalContent, ModalWithOpener },
  props: {
    additionalParams: { type: Object, default: () => ({}) },
    emailRegistrationUrl: { type: String, default: '' },
    lastLoginMethod: { type: String, default: null },
  },
};
</script>
